<script lang="ts">
      import { onMount } from "svelte"
      import { createBreakpointContext } from "./ts/BreakpointContext.svelte"



      onMount(() => {
            const ctrl = new AbortController()
            window.addEventListener('resize', () =>  {
              breakpointContext.getBreakpoint()
              breakpointContext.isPortrait()
            }, { signal: ctrl.signal })
            return () => {
                  ctrl.abort()
            }
      })

      let breakpointContext = createBreakpointContext()

      let { children = undefined } = $props()
</script>

{@render children?.()}
